import YandexMetrika from "../../../vg/services/yandex_metrika/yandexMetrika";
import axios from "axios";

import {
	findID,
	find,
	isEmptyObj,
	mergeDeepObject,
	isObject,
	output_roubles,
	findAll,
	addClass,
	removeClass, eventHandler,
} from "../../../../../modules/vegas/js/util";
import {timeout} from "../../../vg/modules/timeout";

let pendingCartInfo = {};

class VGCatalogCart {

	/**
	 * Добавление в корзину
	 * @param product
	 * @param callback
	 */
	add(product, callback) {
		const _this = this;

		let id = Number(product.getAttribute('data-id') || null),
			title = product.dataset.title || 'Товар',
			cnt = product.querySelector('.qty-info input')?.value || 1;

		axios.post('/cart/add_product', {
			id: id,
			_token: App.csrf,
			cnt: cnt
		}).then((response) => {
			//_this.popup(title + ': добавлен в корзину');
			_this.total(response.data);

			new YandexMetrika().goal('add-to-cart');

			if (typeof callback === "function") {
				return callback(response.data);
			}
		});
	}

	/**
	 * Удаление из корзины
	 * @param product
	 * @param appendParams
	 * @param callback
	 */
	remove(product, appendParams, callback) {
		const _this = this;

		let id = Number(product.getAttribute('data-id') || null);

		let params = mergeDeepObject({
			id: id,
			_token: App.csrf
		}, appendParams)

		if (id) {
			axios.post('/cart/del_product', params).then((response) => {
				_this.total(response.data);
				_this.toggleForm(response.data);
				_this.setFormLoading(false);

				if (typeof callback === "function") {
					return callback(response.data);
				}
			});
		}
	}

	/**
	 * Изменение количества
	 * @param product
	 * @param cnt
	 * @param appendParams
	 * @param callback
	 */
	change(product, cnt, appendParams = {}, callback) {
		const _this = this;

		let id = Number(product.getAttribute('data-id') || null);
		let params = mergeDeepObject({
			id: id,
			cnt: cnt,
			_token: App.csrf
		}, appendParams)

		params = this.formData(params);

		_this.setFormLoading(true);

		axios.post('/cart/change_product', params)
			.then((response) => {
				if (typeof callback === 'function') {
					callback(response.data);
				}

				_this.total(response.data);
				_this.toggleForm(response.data);
				_this.setFormLoading(false);
			});
	}

	/**
	 * Обновляем всё
	 */
	update(appendParams) {
		const _this = this;

		let formData = _this.formData(appendParams);

		let loadingClasses = formData.get('get_delivery_prices') ? 'loading loading-delivery' : 'loading';

		this.setFormLoading(true, loadingClasses);

		axios.post('/cart/totals', formData)
			.then((response) => {
				_this.total(response.data);
				_this.toggleForm(response.data);
				_this.setFormLoading(false, loadingClasses);
			});
	}

	/**
	 * Сколько всего накидали в корзину, выводим цифры
	 * @param data
	 * @returns {boolean}
	 */
	total(data) {
		if ('products_count' in data && typeof data.products_count !== 'undefined') {
			findAll('[data-cart][data-counter=products]').forEach((elem) => {
				elem.setAttribute('data-cnt', data.products_count);
			});
		}

		if ('sums' in data && !isEmptyObj(data.sums)) {
			if ('sum_products' in data.sums && typeof data.sums.sum_products !== 'undefined') {
				findAll('[data-cart][data-counter="products-sum"]').forEach((elem) => {
					elem.setAttribute('data-sum', data.sums.sum_products);

					if (elem.hasAttribute('with-value')) {
						elem.innerHTML = output_roubles(data.sums.sum_products);
					}
				});
			}
		}

		if ('post_tariffs' in data && !isEmptyObj(data.post_tariffs)) {
			let tariffMessage = find('[data-post-tariff-message]');
			if (tariffMessage) {
				tariffMessage.textContent = data.post_tariff_message || '';
				tariffMessage.classList.toggle('d-none', !data.post_tariff_message);
			}

			for (let tariffKey in data.post_tariffs) {
				let tariff = data.post_tariffs[tariffKey];
				let tariffElement = find(`[data-delivery-additional="post"] [data-post-tariff="${tariffKey}"]`);

				if (!tariffElement) continue;

				let input = tariffElement.querySelector('input');
				input.disabled = !tariff.available;
				tariffElement.classList.toggle('disabled', !tariff.available);
				tariffElement.querySelector('[data-post-tariff-price]').innerHTML = tariff.available
					? output_roubles(tariff.price)
					: 'недоступен';
				tariffElement.querySelector('[data-post-tariff-period]').textContent = tariff.delivery_period_text || '';
			}

			let selectedTariff = find(`[data-delivery-additional="post"] [data-post-tariff="${data.post_tariff_selected}"] input`);
			if (selectedTariff && !selectedTariff.checked) {
				selectedTariff.checked = true;
				this.saveCartInfo({post_tariff: selectedTariff.value});
			}

			let officeContainer = find('[data-delivery-additional="post"] [data-post-office-container]');
			officeContainer?.classList.toggle('d-none', selectedTariff?.value === 'ems');

			this.renderPostPackages(data.post_packages || []);
		}

		if ('delivery_prices' in data) {
			for (let deliveryId in data.delivery_prices) {
				let originalPrice = data.delivery_prices[deliveryId];
				let price = isNaN(originalPrice)
					? originalPrice
					: (originalPrice > 0 ? output_roubles(originalPrice) : 'бесплатно');

				let deliveryElem = find(`.delivery-area .form-check-label[for="delivery-type-${deliveryId}"]`)
				if (deliveryElem) {
					deliveryElem.querySelector('.price').innerHTML = price;
				}
			}

			let container = find(`.delivery-area ul`);
			[...container.children]
				.sort((a, b) => {
					let deliveryIdA = a.querySelector('[name=delivery_id]').value;
					let deliveryIdB = b.querySelector('[name=delivery_id]').value;

					let priceA = data.delivery_prices[deliveryIdA]
					let priceB = data.delivery_prices[deliveryIdB]

					if (isNaN(priceA)) priceA = 1000000;
					if (isNaN(priceB)) priceB = 1000000;

					return priceA - priceB;
				})
				.forEach(node => container.appendChild(node));

			let deliveriesIdsExists = Object.keys(data.delivery_prices);
			find('[data-no-delivery]')?.classList.toggle('d-none', deliveriesIdsExists.length > 0);
			[...findAll('.delivery-area [name="delivery_id"]')].forEach(el => {
				let exists = deliveriesIdsExists.indexOf(el.value) === -1;
				el.disabled = exists;
				el.closest('li').classList.toggle('d-none', exists)
			});

			let deliveryActive = find('.delivery-area [name="delivery_id"]:checked');
			if (!deliveryActive || deliveryActive.disabled) {
				if (deliveryActive) deliveryActive.checked = false;
				let firstDeliveryEnabled = find('.delivery-area [name="delivery_id"]:not(:disabled)');
				if (firstDeliveryEnabled) {
					firstDeliveryEnabled.checked = true;
				}
				eventHandler.on(find('.catalog-cart'), 'toggle-additionals');
			}
		}

		if ('payments_info' in data && !isEmptyObj(data.payments_info)) {
			for (let paymentId in data.payments_info) {
				let info = data.payments_info[paymentId];
				let paymentCheckbox = find(`.payment-area #payment-${paymentId}`)
				if (paymentCheckbox) {
					paymentCheckbox.disabled = !info.enabled;
				}
			}

			let activePayment = find('.payment-area .form-check-input:checked');
			if (activePayment && activePayment.disabled) {
				let newActivePayment = find('.payment-area .form-check-input:not(:disabled)');
				if (newActivePayment) {
					newActivePayment.checked = true;
				}
			}
		}

		/*[...findAll('.delivery-area .delivery-section .msg.error')].forEach((el) => {
			el.classList.add('d-none');
			el.innerHTML = '';
		});
		if ('delivery_info' in data && data.delivery_info) {
			let info = data.delivery_info;
			let deliveryElem = find(`.delivery-area .delivery-section[data-id="${info.id}"]`);

			if (typeof info.error_msg !== 'undefined' && deliveryElem) {
				let msgElem = deliveryElem.querySelector('.msg.error');
				if (msgElem) {
					msgElem.insertAdjacentHTML('beforeend', Array(info.error_msg).map(el => {
						return `<div>${el}</div>`;
					}).join(''));
					msgElem.classList.remove('d-none');
				}
			}
		}*/

		totalCartForm(data);
		totalCartProducts(data);

		function totalCartForm(data) {
			let form = findID('form-cart'),
				sums = isObject(data) && ('sums' in data) && isObject(data.sums) ? data.sums : {};

			if (form) {
				// products sum
				let sProducts = form.querySelector('[data-sum="products"]');
				if (sProducts) {
					let sumValue = sProducts.querySelector('[data-sum-value]');
					if (sumValue) {
						let sumProducts = ('sum_products' in sums) ? sums.sum_products : 0
						sumValue.innerHTML = output_roubles(sumProducts)
					}
				}

				// cart sum
				let sTotal = form.querySelector('[data-sum="total"]');
				if (sTotal) {
					let sTotalValue = sTotal.querySelector('[data-sum-value]');
					if (sTotalValue) {
						let sum = ('sum' in sums) ? sums.sum : 0;
						sTotalValue.innerHTML = output_roubles(sum);
					}
				}

				// user discount
				let sUserDiscount = form.querySelector('[data-sum="user_discount"]');
				if (sUserDiscount) {
					let sUserDiscountValue = sUserDiscount.querySelector('[data-sum-value]');
					if (sUserDiscountValue) {
						let sum = ('sum_user_discount' in sums) ? sums.sum_user_discount : 0;
						if (sum > 0) {
							sUserDiscount.classList.remove('d-none');
							sUserDiscountValue.innerHTML = output_roubles(sum);
						} else {
							sUserDiscount.classList.add('d-none');
						}
					}
				}

				// promocode
				/*let sPromocode = form.querySelector('[data-sum=promocode]');
				if (sPromocode && 'sum_promocode' in sums) {
					if (sums.sum_promocode) {
						sPromocode.querySelector('[data-sum-value]').innerHTML = output_roubles(sums.sum_promocode)
						removeClass(sPromocode, 'd-none');
					} else {
						addClass(sPromocode, 'd-none');
					}
				}

				let promoPercent = form.querySelector('.cart-promocode .percent');
				if (promoPercent && ('percent_promocode' in sums)) {
					promoPercent.innerHTML = sums.percent_promocode;
				}*/

				// user discount
				/*let sUserDiscount = form.querySelector('[data-sum=user_discount]');
				if (sUserDiscount) {
					if ('sum_user_discount' in sums && sums.sum_user_discount > 0) {
						let promoSumValue = sUserDiscount.querySelector('[data-sum-value]');
						if (promoSumValue) {
							promoSumValue.innerHTML = output_roubles(sums.sum_user_discount)
						}

						removeClass(sUserDiscount, 'd-none');
					} else {
						addClass(sUserDiscount, 'd-none');
					}
				}*/

				// delivery sum
				let sDelivery = form.querySelector('[data-sum="delivery"]');
				if (sDelivery) {
					if ('sum_delivery' in sums) {
						let deliverySumValue = sDelivery.querySelector('[data-sum-value]');

						if (deliverySumValue) {
							if (sums.sum_delivery === null) {
								deliverySumValue.innerHTML = 'индивидуально';
								//addClass(deliverySumValue, 'error');
							} else {
								removeClass(deliverySumValue, 'error');
								deliverySumValue.innerHTML = isNaN(sums.sum_delivery) ? sums.sum_delivery : (
									sums.sum_delivery > 0 ? output_roubles(sums.sum_delivery) : 'бесплатно'
								)
							}
						}

						removeClass(sDelivery, 'd-none');
					} else {
						addClass(sDelivery, 'd-none')
					}
				}
			}
		}

		function totalCartProducts(data) {
			let cartProducts = find('.catalog-cart--products');
			if (cartProducts && ('products_totals' in data) && data.products_totals) {
				for (let i in data.products_totals) {
					let p = data.products_totals[i];

					let cartPivot = cartProducts.querySelector(`[data-product-cart-item][data-pivot_id="${p.pivot_id}"]`);
					if (cartPivot) {
						[...cartPivot.querySelectorAll('.price-total')].forEach((el => {
							el.innerHTML = output_roubles(p.price_total)
						}));
					}
				}
			}
		}
	}

	renderPostPackages(packages) {
		let container = find('[data-delivery-additional="post"] [data-post-packages]');
		let list = container?.querySelector('[data-post-packages-list]');
		if (!container || !list) return;

		list.replaceChildren();
		container.classList.toggle('d-none', !packages.length);

		packages.forEach((postPackage) => {
			let packageElement = document.createElement('div');
			packageElement.className = 'border rounded p-3 mb-2';

			let title = document.createElement('b');
			title.textContent = `Место ${postPackage.number} — ${this.outputPostWeight(postPackage.weight)}`;
			if (!isNaN(postPackage.price)) {
				title.textContent += ` — ${output_roubles(postPackage.price)}`;
			}
			packageElement.appendChild(title);

			let items = document.createElement('ul');
			items.className = 'small mb-0 mt-2 ps-3';
			(postPackage.items || []).forEach((item) => {
				let itemElement = document.createElement('li');
				let sku = item.sku ? ` (${item.sku})` : '';
				itemElement.textContent = `${item.title}${sku} × ${item.quantity} — ${this.outputPostWeight(item.weight)}`;
				items.appendChild(itemElement);
			});
			packageElement.appendChild(items);
			list.appendChild(packageElement);
		});
	}

	outputPostWeight(weight) {
		return `${(Number(weight) / 1000).toLocaleString('ru-RU', {maximumFractionDigits: 3})} кг`;
	}

	/**
	 *
	 * @param params
	 * @param toArray
	 */
	formData(params = {}, toArray = false) {
		let form = this.getForm();
		let formData = null;

		formData = form ? new FormData(form) : new FormData();
		for (let name in params) {
			formData.append(name, params[name]);
		}

		if (formData && toArray) {
			let res = {};

			let components = Array.from(formData);
			for (let item of components) {
				res[item[0]] = item[1];
			}

			return res;
		}

		return formData;
	}

	getForm() {
		return findID('form-cart');
	}

	toggleForm(data) {
		let form = this.getForm();

		if (form) {
			form.disabled = data.disable;
			form.classList.toggle('disabled', data.disable);

			let error = form.querySelector('.order-msg');
			error.classList.toggle('d-none', !data.disable);
			error.innerHTML = data.disable_text;
		}
	}

	setFormLoading(loading, loadingClass = 'loading') {
		let form = this.getForm();

		if (form) {
			loadingClass.split(' ').forEach(className => {
				form.classList.toggle(className, loading)
			})

			let btn = form.querySelector('button[type=submit]');
			if (btn) {
				btn.disabled = !!loading;
			}

			if (form.disabled) {
				btn.disabled = true;
			}
		}
	}

	saveCartInfo(data) {
		Object.assign(pendingCartInfo, data);

		timeout('cart_save_info', 1000, () => {
			const dataToSave = pendingCartInfo;
			pendingCartInfo = {};

			axios.post('/cart/save_cart_info', dataToSave);
		});
	}
}

export default VGCatalogCart
